import React from 'react';
import numeral from 'numeral';
import { Link, TableRow, IconButton } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { TableRowsContainer, Cell } from './styles';
import PropTypes from 'prop-types';

const Row = ({
  row,
  handleClickOpenCloseIR,
  handleOpenRow,
  selectedSubRow,
  handleSelectedSubRow
}) => {
  return (
    <TableRowsContainer>
      <TableRow style={{ background: row.open ? '#f8984e' : '#fff' }}>
        <Cell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => handleOpenRow(row)}
          >
            {row.open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </Cell>
        <Cell component="th" scope="row">{row.npo}</Cell>
        <Cell>{`${numeral(row.measurement).format('0.0')}%`}</Cell>
        <Cell>{row.relevantResults}</Cell>
        <Cell>{row.gResults}</Cell>
        <Cell>{row.mResults}</Cell>
        <Cell>{row.eResults}</Cell>
      </TableRow>
      {row.open &&
        row.details.map(detailsRow => (
          <TableRow
            key={detailsRow.npo}
            onClick={() => handleSelectedSubRow(detailsRow.report)}
            style={{
              background:
                detailsRow.report === selectedSubRow ? '#f8984e' : '#fff'
            }}
          >
            <Cell />
            <Cell component="th" scope="row">
              <Link
                component="button"
                variant="body2"
                onClick={() => handleClickOpenCloseIR(true)}
                style={{
                  color:
                    detailsRow.report !== selectedSubRow ? '#f8984e' : '#fff'
                }}
              >
                {detailsRow.report}
              </Link>
            </Cell>
            <Cell>{`${numeral(detailsRow.measurement).format('0.0')}%`}</Cell>
            <Cell>{ detailsRow.relevantResults}</Cell>
            <Cell>{detailsRow.gResults}</Cell>
            <Cell>{detailsRow.mResults}</Cell>
            <Cell>{detailsRow.eResults}</Cell>
          </TableRow>
        ))}
    </TableRowsContainer>
  );
};


Row.propTypes = {
  row: PropTypes.object,
  handleClickOpenCloseIR: PropTypes.func,
  handleOpenRow: PropTypes.func,
  selectedSubRow: PropTypes.object,
  handleSelectedSubRow: PropTypes.func,
};

export default Row;
